export const ANALYTICS_CONSTANTS = {
	COMPONENT_NAME: `connected-service-vin-checker`,
	COMPONENT_GROUP: `tools`,
	CHANNEL: `com.toyota.tme.t1.statistics`,
	TOPIC: `onTrack`,
	STEPS: {
		TYPE_VIN: `type-vin`,
		VIN_FOUND: `vin-found`,
		ERROR: `error-message`
	},
	LABELS: {
		ERROR_INVALID_VIN: `invalid-vin`,
		ERROR_SYSTEM: `system-error`,
		ERROR_NON_EXISTING_VIN: `non-existing-vin`,
		ERROR_PROACE: `proace-error`
	},
	EVENTS: {
		COMPONENT_EVENT: `componentevent`
	}
};
